import { SimComponent } from './components/sim/sim.component';
import { AltaSimComponent } from './components/sim/alta-sim/alta-sim.component';
import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';

import { SimsComponent } from './sims.component';

const routes: Routes = [
  {
    path: '',
    children: [
      {
        path: 'sim',
        component: SimComponent
      },
      {
        path: 'sim/alta',
        component: AltaSimComponent
      },
      {
        path: 'sim/editar/:idSim',
        component: AltaSimComponent
      }
    ]
  }
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule]
})
export class SimsRoutingModule { }
